import { Navigate, Outlet } from "react-router-dom";

export function ProtectedRoute({ groupNo, role, isAllowed, redirectTo = "/403" }) {
  if (!isAllowed) {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}